import { render, staticRenderFns } from "./ManageOffers.vue?vue&type=template&id=240cdf5d&scoped=true&"
import script from "./ManageOffers.vue?vue&type=script&lang=js&"
export * from "./ManageOffers.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=240cdf5d&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "@/assets/styles/multiselect.css?vue&type=style&index=2&prod&lang=css&"
import style3 from "./ManageOffers.vue?vue&type=style&index=3&id=240cdf5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240cdf5d",
  null
  
)

export default component.exports